export enum SidebarAction {
  Toggle,
  Close,
  Open
}

export type ContentType = 'docs' | 'api';

export type APIDomainVersion = 'secure_2.3' | 'ally_2.3';